<template>
    <div class="elContent">
        <div class = "main-content">
            <template v-if = "props.toolbarText!=''">
                <div class="content-title">
                    {{props.toolbarText}}
                </div>
                <slot/>
            </template>
            <template v-else>
                <slot/>
            </template>
            
        </div>
    </div>
</template>
<script setup>
import toolbar from '@/components/common/qtBase/toolbar.vue';
const props = defineProps({
    toolbarText: {
        type: String,
        default: ''
    }
});
</script>
<style scoped lang="scss">
.elContent{
    .content-title{
        color: #909399;
        height:17px;
        font-size: 12px;
        font-weight: 500;
        border-bottom:1px solid #EBECEC;
        margin-bottom:8px;
    }
   
}
</style>